import { useRouter as useRouterCore } from '@obtainly/hooks';
import { routes } from 'src/core/config/routes';
export function useRouter(routeId) {
    if (routeId === void 0) { routeId = ''; }
    return useRouterCore(routeId, routes);
}
